import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Courses from "./components/Courses/Courses";
import Contact from "./components/Contact/Contact";
// import "./styles.css";
import "./App.css"
import Testimonial from "./Pages/Testimonial/Testimonial";
import Footer from "./components/Footer/Footer";

function App() {
  return (

    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/testimonial" element={<Testimonial/>} />
      </Routes>

      
      <Footer/>
    </Router>


  );
}

export default App;
